import React from 'react';

import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { PlanDetails } from '~/app/application/features/auth/presentation/plans-infos-sales/plans-list';
import {
  TableBodyCell,
  TableHeaderCell
} from '~/app/application/features/components/plan-details-sales-table/plan-details-table-styles';

type PlansTableProps = {
  plansData: PlanDetails[];
};

export default function PlanDetailsTable({ plansData }: PlansTableProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      {plansData.map((module) => (
        <TableContainer key={module.module}>
          <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
            <TableHead>
              <TableRow>
                <TableHeaderCell coltype='label'>
                  <span className='module'>{module.module}</span>
                  {module.description && (
                    <span className='description'>{module.description}</span>
                  )}
                </TableHeaderCell>
                <TableHeaderCell coltype='plan1'>
                  Plano Enterprise 1
                </TableHeaderCell>
                <TableHeaderCell coltype='plan2'>
                  Plano Enterprise 2
                </TableHeaderCell>
                <TableHeaderCell coltype='plan3'>
                  Plano Enterprise 3
                </TableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {module.values.map((row, idx) => (
                <TableRow key={idx}>
                  <TableBodyCell strong={false} highlight={row.highlight}>
                    {row.label}
                  </TableBodyCell>
                  <TableBodyCell
                    strong={row.strong}
                    highlight={row.highlight}
                    align='center'
                  >
                    {row.enterprise1}
                  </TableBodyCell>
                  <TableBodyCell
                    strong={row.strong}
                    highlight={row.highlight}
                    align='center'
                  >
                    {row.enterprise2}
                  </TableBodyCell>
                  <TableBodyCell
                    strong={row.strong}
                    highlight={row.highlight}
                    align='center'
                  >
                    {row.enterprise3}
                  </TableBodyCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ))}
    </div>
  );
}
